import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Swal from "sweetalert2";
import Header from "../../component/Header";
import Pagination from "../../component/Pagination";
import IconDelete from "../../component/SvgIcons/IconDelete";
import IconSearch from "../../component/SvgIcons/IconSearch";
import IconUpdownFilter from "../../component/SvgIcons/IconUpdownFilter";
import api from "../../Services/api";

import { COUNTRY_TIMEZONE } from "../../Services/countryTime";
export default function Enquiries() {
  const [enquiries, setEnquiries] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    const handleResize = () => {
      setItemsPerPage(window.innerWidth >= 1920 ? 20 : 10);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const response = await api.post("/GetEnquiries");
        setEnquiries(response.data);
      } catch (error) {
        console.error("Error fetching enquiries:", error);
      }
    };
    fetchEnquiries();
  }, []);

  // DB me time UTC me save hota hai; admin me hamesha is desh ke timezone me dikhate hain (dekhne wale ke system ke nahi)
  const formatDate = (value) => {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat("en-GB", {
        timeZone: COUNTRY_TIMEZONE,
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
        .formatToParts(new Date(value))
        .map((p) => [p.type, p.value])
    );
    return `${parts.day}-${parts.month}-${parts.year} ${parts.hour}:${parts.minute} ${String(parts.dayPeriod).toUpperCase()}`;
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedEnquiries = [...enquiries].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const query = searchQuery.toLowerCase();
  const filteredEnquiries = sortedEnquiries.filter(
    (item) =>
      formatDate(item.created_at).includes(searchQuery) ||
      [item.name, item.email, item.phone, item.company, item.interested_in, item.message, item.source_page].some(
        (field) => String(field || "").toLowerCase().includes(query)
      )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEnquiries = filteredEnquiries.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredEnquiries.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this enquiry?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (!result.isConfirmed) return;

    try {
      await api.post(`/EnquiryDelete/${id}`);
      setEnquiries((prev) => prev.filter((item) => item.id !== id));
      Swal.fire("Deleted!", "Enquiry deleted successfully.", "success");
    } catch (error) {
      console.error("Error deleting enquiry:", error);
      Swal.fire("Error", "Failed to delete enquiry.", "error");
    }
  };

  return (
    <section className="eventpage">
      <Header pageTitle="Customer Enquiry Details" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-between align-items-center topsearchbar">
          <div className="d-flex align-items-center gap-2">
            <Link to="#" onClick={() => handleSort("created_at")}>
              <IconUpdownFilter />
            </Link>
          </div>

          <div className="input-container">
            <input
              type="text"
              id="search"
              placeholder="Search Here.."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <span className="underline"></span>
            <div className="search-icon">
              <IconSearch />
            </div>
          </div>
        </div>

        <div className="tableheader d-flex flex-column gap-4">
          <div className="event-detailstable">
            <table className="table">
              <thead>
                <tr>
                  <th width="10px" align="center">Sr. No.</th>
                  <th>Date & Time (UAE)</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Company</th>
                  <th>Interested In</th>
                  <th style={{ minWidth: "320px" }}>Message</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentEnquiries.length > 0 ? (
                  currentEnquiries.map((item, index) => (
                    <tr key={item.id}>
                      <td align="center">{indexOfFirstItem + index + 1}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{formatDate(item.created_at)}</td>
                      <td>{item.name}</td>
                      <td>{item.email}</td>
                      <td>{item.phone}</td>
                      <td>{item.company || "-"}</td>
                      <td>{item.interested_in || "-"}</td>
                      <td
                        style={{ whiteSpace: "normal", minWidth: "320px", maxWidth: "420px" }}
                        data-tooltip-id={`enq-msg-${item.id}`}
                        data-tooltip-content={item.message}
                      >
                        {item.message && item.message.length > 120
                          ? `${item.message.substring(0, 120)}...`
                          : item.message}
                        <Tooltip
                          id={`enq-msg-${item.id}`}
                          place="top"
                          effect="solid"
                          style={{ whiteSpace: "normal", maxWidth: "400px" }}
                        />
                      </td>
                      <td>
                        <div className="action">
                          <Link
                            to="#"
                            onClick={() => handleDelete(item.id)}
                            data-tooltip-id={`enq-del-${item.id}`}
                            data-tooltip-content="Delete"
                          >
                            <IconDelete />
                          </Link>
                          <Tooltip id={`enq-del-${item.id}`} place="top" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: "center", padding: "10px" }}>
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={filteredEnquiries.length > itemsPerPage ? totalPages : 0}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}
